module.exports = __webpack_public_path__ + "media/images/home/ic_resend_email-c37990f2f29c28d28931a99e6a3210c8.svg";